<template>
    <a v-if="target === '_blank'" :href="href" :class="classes" target="_blank">
        <slot />
        <svg class="ml-1 w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
            <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
        </svg>
    </a>
    <a v-else-if="external" :href="href" :class="classes">
        <slot />
    </a>
    <Link v-else :href="href" :class="classes">
        <slot />
    </Link>
</template>

<script>
    import { Link } from '@inertiajs/inertia-vue3'

    export default {
        props: {
            href: {
                type: String,
                required: true
            },
            active: {
                type: Boolean,
                defualt: false
            },
            target: {
                type: String,
                default: null
            },
            external: {
                type: Boolean,
                default: false
            },
            class: {
                type: String,
                default: ''
            }
        },

        components: {
            Link,
        },

        computed: {
            classes() {
                return this.active
                            ? `inline-flex items-center px-1 pt-1 border-b-2 border-white text-sm font-medium leading-5 text-gray-900 focus:outline-none focus:border-white transition duration-150 ease-in-out ${this.class}`
                            : `inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-white focus:outline-none focus:text-gray-700 focus:border-white transition duration-150 ease-in-out ${this.class}`
            }
        }
    }
</script>
